import { OrganizationUserStatusType as SdkOrganizationUserStatusType } from "@bitwarden/sdk-internal";

// Re-export the SdkOrganizationUserStatusType so we have a single source of truth
export {
  /** @deprecated Import directly from @bitwarden/sdk-internal instead. **/
  SdkOrganizationUserStatusType as OrganizationUserStatusType,
};
